/**
 * Created by charnjeetelectrovese@gmail.com on 4/30/2020.
 */
import {DASHBOARD_INIT, DASHBOARD_DONE, DASHBOARD_TABLE_INIT,DASHBOARD_TABLE_DONE} from "../actions/Dashboard.action";

const initialState = {
    error: false,
    is_calling: true,
    total_users: 0,
    week_users: 0,
    total_deals: 0,
    special_deals: 0,
    closed_deals: 0,
    week_closed: 0,
    pending_deals: 0,
    today_pending: 0,
    reported_deals: 0,
    monthly_reported: 0,
    spotlite_categories: [],
    request_categories: [],
    top_users: [],
    session_data: [],
    is_fetching: true,
    recent_deals: [],
    top_deals: [],
    top_reported_deals: [],
    top_reported_users: []
};

export default function (state = JSON.parse(JSON.stringify(initialState)), action) {
    switch (action.type) {
        case DASHBOARD_INIT: {
            return {...state, is_calling: true };
        }
        case DASHBOARD_DONE: {
            return {
                ...state,
                ...action.payload,
                is_calling: false
            }
        }
        case DASHBOARD_TABLE_INIT: {
            return {...state, is_fetching: true };
        }
        case DASHBOARD_TABLE_DONE: {
           const {recent_deals,top_deals,top_reported_deals,top_reported_users} = action.payload
            return {
               ...state,
                recent_deals: recent_deals,
                top_deals: top_deals,
                top_reported_deals: top_reported_deals,
                top_reported_users: top_reported_users,
                is_fetching: false,
            }
        }
        default: {
            return state;
        }
    }
    return state;
}
